import { NgClass } from '@angular/common';
import { Component, input, ChangeDetectionStrategy, output, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { TABLE_PAGINATION_DEFAULT_CONFIG } from '@app/utils/constants/table-pagination.constants';
import { TablePaginationConfig } from '@app/utils/interfaces/table-pagination.interface';

@Component({
  selector: 'app-table-pagination',
  standalone: true,
  imports: [
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    FormsModule,
    NgClass,
    MatIconModule,
    TranslateModule,
  ],
  templateUrl: './table-pagination.component.html',
  styleUrls: ['./table-pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TablePaginationComponent {
  public pageChange = output<number>();
  public pageSizeChange = output<number>();
  public pagination = input<TablePaginationConfig>(TABLE_PAGINATION_DEFAULT_CONFIG);

  protected totalPages = computed(() => {
    const { totalItems, pageSize } = this.pagination();
    return Math.ceil(totalItems / pageSize);
  });

  protected pageArray = computed(() => {
    return this.getPageArray();
  });

  private range(start: number, end: number): number[] {
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }

  private getPageArray(): (number | null)[] {
    const total = this.totalPages();
    const current = this.pagination().currentPage;

    if (total <= 7) return this.range(1, total);

    if (current <= 4) return [1, ...this.range(2, 5), null, total];
    if (current >= total - 3) return [1, null, ...this.range(total - 4, total)];
    return [1, null, ...this.range(current - 1, current + 1), null, total];
  }

  protected changePage(page: number): void {
    if (page === this.pagination().currentPage) return;

    this.pageChange.emit(page);
  }

  protected changePageSize(size: number): void {
    this.pageSizeChange.emit(size);
  }
}
